import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import FormFieldsTable from "../../components/forms/FormFieldsTable";
import TextInputField from "../../components/forms/TextInputField";
import DateInputField from "../../components/forms/DateInputField";
import DropDownInputField from "../../components/forms/DropDownInputField";
import FormError from "../../components/forms/FormError";


const upcase = (value) => value && value.toUpperCase();

class RecordPaymentForm extends Component {

  render() {
    let {errors, handleSubmit, submitting, paymentMethods} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field 
              label="Payment Method"
              name="paymentMethod"
              component={DropDownInputField}
              data={paymentMethods}
              valueKey="id"  
              titleKey="title" 
              showBlank={true}
              serverError={this.props.errors.paymentMethod}
              />
            <Field 
              label="Amount (e.g. 400.45)"
              name="amount"
              component={TextInputField}
              serverError={this.props.errors.amount}
              />
            <Field 
              label="Currency (e.g. USD)"
              name="currency"
              component={TextInputField}
              normalize={upcase}
              serverError={this.props.errors.currency}
              />
            <Field 
              label="Payment Date"
              name="paymentDate"
              component={DateInputField}
              showDatePicker={this.props.showDatePicker}
              serverError={this.props.errors.paymentDate}
              />
            <Field 
              label="Transaction Ref Nr"
              name="transactionRef"
              component={TextInputField}
              serverError={this.props.errors.transactionRef}
              />
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton onClick={handleSubmit(values => this.props.onSubmit(values))} label={submitLabel} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }

}

const ReduxForm = reduxForm({
  form: "RecordPaymentForm"
})(RecordPaymentForm);

export default ReduxForm;